import React, { useState } from 'react';
import { SchoolDetailsTab } from './SchoolDetailsTab';
import { SchoolStudentsTab } from './SchoolStudentsTab';
import { SchoolTeachersTab } from './SchoolTeachersTab';
import { SchoolEventsTab } from './SchoolEventsTab';
import { SchoolScheduleTab } from './SchoolScheduleTab';

type TabType = 'details' | 'students' | 'teachers' | 'events' | 'schedule';

const tabs: { id: TabType; label: string }[] = [
  { id: 'details', label: 'School Details' },
  { id: 'students', label: 'Students' },
  { id: 'teachers', label: 'Teachers' },
  { id: 'events', label: 'Events' },
  { id: 'schedule', label: 'Schedule' },
];

export function MySchoolPage() {
  const [activeTab, setActiveTab] = useState<TabType>('details');

  return (
    <div>
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">My School</h1>
        <p className="text-gray-500">Manage your school details, students, teachers, and events</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex gap-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`pb-3 text-sm font-medium transition-colors relative ${
                activeTab === tab.id
                  ? 'text-teal-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
              {activeTab === tab.id && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-teal-600" />
              )}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'details' && <SchoolDetailsTab />}
      {activeTab === 'students' && <SchoolStudentsTab />}
      {activeTab === 'teachers' && <SchoolTeachersTab />}
      {activeTab === 'events' && <SchoolEventsTab />}
      {activeTab === 'schedule' && <SchoolScheduleTab />}
    </div>
  );
}
